// Allowed email addresses or domains for preprod access
const ALLOWED_EMAILS = ['benoit@inboundx.app'];

// Allowed domains (anyone with these domains can access)
const ALLOWED_DOMAINS = [
    'hexa.com',
    'inboundx.app',
    'userose.ai',
    // Add domains here
];

export function isUserAllowed(email: string): boolean {
    // In local dev mode, allow all authenticated users
    if (import.meta.env.DEV) {
        return true;
    }

    // Check specific emails
    if (ALLOWED_EMAILS.includes(email.toLowerCase())) {
        return true;
    }

    // Check domains
    const domain = email.split('@')[1]?.toLowerCase();
    if (domain && ALLOWED_DOMAINS.includes(domain)) {
        return true;
    }

    return false;
}
